//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"SelectedConfigurationName",1,0],[0,"SelectedConfigurationPart",1,"Part",0]],[[["instanceNames"],"RefreshRegisteredInstances",{},1,1],[["configurationName","signalInfo"],"SetSignals",{},2,1],[["configurationName","numSignal"],"GetSignals",{R_:{tagInfos:""}},1,1],[["configurationName","signalInfo"],"SetSignalsEx",{},2,1],[["configurationName","numSignal"],"GetSignalsEx",{R_:{tagInfos:""}},1,1],[["configurationName","ownerPart","signalInfo"],"SetSignalsExV2",{},3,0],[["configurationName","ownerPart","numSignal"],"GetSignalsExV2",{R_:{tagInfos:""}},2,0],[["instanceName","eEndianType","strStatus"],"SetSHMInstance",{},3,1],[["instanceName","eEndianType","strStatus"],"GetSHMInstance",{},1,1],[["instanceNames","isEditInstanceName"],"RefreshInstances",{},2,1],[["instanceName","ownerPart","eEndianType","strStatus"],"SetSHMInstanceV2",{},4,0],[["instanceName","ownerPart"],"GetSHMEndianType",{R_:{eEndianType:''}},2,0],[["instanceName","ownerPart"],"GetSHMStatus",{R_:{strStatus:''}},2,0],[["numInstance","instanceNames"],"GetInstanceNames",{},0,0],[["instanceNames"],"RefreshInstancesV2",{},1,1],[["ownerPart","instanceNames"],"RefreshInstancesV3",{},2,0],[["oldInstanceName","newInstanceName"],"ChangeInstanceName",{},2,1],[["oldInstanceName","ownerPart","newInstanceName"],"ChangeInstanceNameV2",{},3,0]],[]];
SPLM.Mechatronics.SHMSignalClientBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.SHMSignalClientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.SHMSignalClientBuilder.SHMSignal = class{
    constructor(signalName,eDataType,value,eIOType){
        this.signalName=signalName;this.eDataType=eDataType;this.value=value;this.eIOType=eIOType;}
    get Signalname(){return this.signalName}
    set Signalname(val){this.signalName = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
    get Value(){return this.value}
    set Value(val){this.value = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
};

SPLM.Mechatronics.SHMSignalClientBuilder.SHMSignalEx = class{
    constructor(signalName,strDataTypeName,value,eIOType){
        this.signalName=signalName;this.strDataTypeName=strDataTypeName;this.value=value;this.eIOType=eIOType;}
    get Signalname(){return this.signalName}
    set Signalname(val){this.signalName = val}
    get Strdatatypename(){return this.strDataTypeName}
    set Strdatatypename(val){this.strDataTypeName = val}
    get Value(){return this.value}
    set Value(val){this.value = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
};

SPLM.Mechatronics.SHMSignalClientBuilder.SHMInfo = class{
    constructor(name,endianType,status){
        this.name=name;this.endianType=endianType;this.status=status;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Endiantype(){return this.endianType}
    set Endiantype(val){this.endianType = val}
    get Status(){return this.status}
    set Status(val){this.status = val}
};

SPLM.Mechatronics.SHMSignalClientBuilder.EndianType = Object.freeze({
    "Little" : "Little", "Big" : "Big"});

export default SPLM;